import { Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/do";
import { UserService } from "../user/user.service";
import { environment } from "../../../../environments/environment";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material";

@Injectable()
export class CommonHttpInterceptor implements HttpInterceptor {
  private baseUrl;
  constructor(
    private inj: Injector,
    private router: Router,
    public snackBar: MatSnackBar
  ) {
    this.baseUrl = environment["baseUrl"];
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let userService = this.inj.get(UserService);
    let headers = req.headers;
    headers = headers
    .set("Content-Language", "en");
    if (userService.isAuthenticated()) {
        if(req.url.search('Image') != -1 || (req.body && req.body.constructor == FormData)){
          headers = headers
            .set("Authorization", "Bearer " + userService.getToken());
            headers.delete("Content-Type");
        }else{
          headers = headers
          .set("Authorization", "Bearer " + userService.getToken())
          .set("Content-Type", "application/json");
        }
    }


    let reqCloned = req.clone({
      url: this.baseUrl + req.url,
      headers: headers
    });

    if (req.url.search("assets") > 0) {
      reqCloned = req;
    }

    return next.handle(reqCloned).do(
      (event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // show message in snakeBar if message key available
          if (event.body && event.body.code == 0 && event.body.message) {
            this.snackBar.open(event.body.message, "", {
              duration: 3000
            });
          }
        }
      },
      (err: any) => {
        //handle errors in global section
        if (err instanceof HttpErrorResponse) {
          if (err.error.code === 401) {
            // redirect to the login route
            // or show a modal
            userService.logout();
            return;
          }

          if (err.error && err.error.code && err.error.message) {
            this.snackBar.open(err.error.message, "", {
              duration: 2000
            });
          }
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/http-interceptor/http.interceptor.ts